import { MultiValue } from "react-select";
import { CleaningRouteList, InitialRouteDetailItem } from "./state";
import { BinInfo } from "../staticInfo/state";

export function initCleaningRouteListAction(
    cleaningRouteList: CleaningRouteList[]
) {
    return {
        type: "@@cleaningRouteState/initCleaningRouteListAction" as const,
        cleaningRouteList,
    };
}

export function initSelectedCleaningRouteDetailAction(
    selectedBinInfo: MultiValue<BinInfo>,
    cleaningRoute: CleaningRouteList
) {
    return {
        type: "@@cleaningRouteState/initSelectedCleaningRouteDetailAction" as const,
        selectedBinInfo,
        cleaningRoute,
    };
}

export function changeCleaningDetailRouteAction(
    selectedBinInfo: MultiValue<BinInfo>
) {
    return {
        type: "@@cleaningRouteState/changeCleaningDetailRouteAction" as const,
        selectedBinInfo,
    };
}

export function changeCleaningRouteNameAction(route_name: string) {
    return {
        type: "@@cleaningRouteState/changeCleaningRouteNameAction" as const,
        route_name,
    };
}

export function handleEffectiveDateChangeAction(effective_date: Date) {
    return {
        type: "@@cleaningRouteState/handleEffectiveDateChangeAction" as const,
        effective_date,
    };
}

export function handleCleanerChangeAction(cleaner_id: string) {
    return {
        type: "@@cleaningRouteState/handleCleanerChangeAction" as const,
        cleaner_id,
    };
}

export function handlCleaningRouteWeekdayChange(weekday: string) {
    return {
        type: "@@cleaningRouteState/handlCleaningRouteWeekdayChange" as const,
        weekday,
    };
}

export function setHolidayAction(holiday: number) {
    return {
        type: "@@cleaningRouteState/setHolidayAction" as const,
        holiday,
    };
}

export function setWeekdayFlagsAction(payload: {
    mon?: number;
    tue?: number;
    wed?: number;
    thu?: number;
    fri?: number;
    sat?: number;
    sun?: number;
}) {
    return {
        type: "@@cleaningRouteState/setWeekdayFlagsAction" as const,
        payload,
    };
}

export function handlCleaningRouteRemarksChangeAction(remarks: string) {
    return {
        type: "@@cleaningRouteState/handlCleaningRouteRemarksChangeAction" as const,
        remarks,
    };
}

export function handleCleaningRouteStartTimeAction(
    start_time: string,
    index: number
) {
    return {
        type: "@@cleaningRouteState/handleCleaningRouteStartTimeAction" as const,
        start_time,
        index,
    };
}

export function handleCleaningRouteEndTimeAction(
    end_time: string,
    index: number
) {
    return {
        type: "@@cleaningRouteState/handleCleaningRouteEndTimeAction" as const,
        end_time,
        index,
    };
}

export function handlClearCleaningRouteAction() {
    return {
        type: "@@cleaningRouteState/handlClearCleaningRouteAction" as const,
    };
}

export function setInitialRouteDetailsAction(
    initialRouteDetails: InitialRouteDetailItem[] | null
) {
    return {
        type: "@@cleaningRouteState/setInitialRouteDetailsAction" as const,
        initialRouteDetails,
    };
}

export type CleaningRouteAction =
    | ReturnType<typeof initCleaningRouteListAction>
    | ReturnType<typeof initSelectedCleaningRouteDetailAction>
    | ReturnType<typeof changeCleaningDetailRouteAction>
    | ReturnType<typeof changeCleaningRouteNameAction>
    | ReturnType<typeof handleEffectiveDateChangeAction>
    | ReturnType<typeof handleCleanerChangeAction>
    | ReturnType<typeof handlCleaningRouteWeekdayChange>
    | ReturnType<typeof setWeekdayFlagsAction>
    | ReturnType<typeof setHolidayAction>
    | ReturnType<typeof handlCleaningRouteRemarksChangeAction>
    | ReturnType<typeof handleCleaningRouteStartTimeAction>
    | ReturnType<typeof handleCleaningRouteEndTimeAction>
    | ReturnType<typeof handlClearCleaningRouteAction>
    | ReturnType<typeof setInitialRouteDetailsAction>;
